export default (partialValue: number, totalValue: number): string => {
  const percentage = (1 - partialValue / totalValue) * 100;

  if (percentage < 1) {
    return '';
  }

  return -Math.round(percentage) + '%';
};
